export default __webpack_public_path__ + "static/media/tag-green.378d5a2f.svg";